import { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
// import EthereumConnect from 'Register/EthereumConnect/EthereumConnect';
// import RegisterDialogContainer from 'Register/RegisterDialogContainer';
// import RegisterInformation from 'Register/RegisterInformation';
// import RegisterType from 'Register/RegisterType';
// import RegisterVerification from 'Register/RegisterVerification';
// import RegisterWelcome from 'Register/RegisterWelcome';
// import ForgotPassword from 'Signin/ForgotPassword';
// import NewPassword from 'Signin/NewPassword';
// import RequestInvitation from 'Signin/RequestInvitation';
// import SignIn from 'Signin/SignIn';
// import SigninDialogContainer from 'Signin/SigninDialogContainer';

const modalRoutes = {
  // "signin": {
  //     component: (props) => <SigninDialogContainer {...props} />,
  //     childs: {
  //         "default": {
  //             component: (props) => <SignIn {...props} />
  //         },
  //         "request": {
  //             component: (props) => <RequestInvitation {...props} />
  //         },
  //         "forgot": {
  //             component: (props) => <ForgotPassword {...props} />
  //         },
  //         "new-password": {
  //             component: (props) => <NewPassword {...props} />
  //         },
  //     }
  // },
  // "welcome": {
  //     component: (props) => <RegisterWelcome {...props} />,
  // },
  // "register": {
  //     component: (props) => <RegisterDialogContainer {...props} />,
  //     childs: {
  //         "default": {
  //             component: (props) => <RegisterInformation {...props} />
  //         },
  //         "verification": {
  //             component: (props) => <RegisterVerification {...props} />
  //         },
  //         "type": {
  //             component: (props) => <RegisterType {...props} />
  //         },
  //         "wallet": {
  //             component: (props) => <EthereumConnect {...props} />,
  //         }
  //     }
  // },
};

const buildModal = (routes = []) => {
  const props = { child: null };
  if (routes.length === 0) return null;
  const mainModal = modalRoutes[routes[0]];
  if (!mainModal) return null;
  if (routes[1] !== null && routes[1] === '') routes[1] = 'default';
  if (mainModal.childs && mainModal.childs.default && !routes[1]) routes.push('default');
  if (routes[1] && mainModal.childs) {
    const subModal = mainModal.childs[routes[1]];
    if (subModal) {
      props.child = subModal.component();
    }
  }
  return mainModal.component(props);
};

export const closeModal = (location, history) => {
  const queryParams = new URLSearchParams(location.search);
  console.log(queryParams);
  history.replace({
    search: queryParams.toString(),
  });
};

export const makeModalRoute = (location, newRoute) => {
  const queryParams = new URLSearchParams(location.search);
  queryParams.set('modal', newRoute);
  return `${location.pathname}?${queryParams.toString().replace('%2F', '/')}`;
};

const ModalContentProvider = ({ location }) => {
  const [modal, setModal] = useState(null);
  useEffect(() => {
    const modalPath = location.search
      .substr(1)
      .split('&')
      .filter((x) => x.indexOf('modal') !== -1)[0];
    if (modalPath) {
      setModal(buildModal(modalPath.substr(6).split('/')));
    } else {
      setModal(null);
    }
  }, [location]);

  return modal;
};

export default withRouter(ModalContentProvider);
